class InfiniteScroll {
  constructor() {
    this.productGrid = document.getElementById('product-grid');
    this.trigger = document.querySelector('.infinite-scroll-trigger');
    this.loading = document.querySelector('.infinite-scroll-loading');
    this.endMessage = document.querySelector('.infinite-scroll-end');

    if (!this.productGrid || !this.trigger) return;

    this.isLoading = false;
    this.currentPage = parseInt(this.trigger.dataset.currentPage);
    this.totalPages = parseInt(this.trigger.dataset.totalPages);
    this.nextUrl = this.trigger.dataset.nextUrl;

    this.init();
  }

  init() {
    // Use Intersection Observer for better performance
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isLoading && this.nextUrl) {
            this.loadMore();
          }
        });
      },
      {
        rootMargin: '400px', // Start loading 400px before reaching the trigger
      }
    );

    this.observer.observe(this.trigger);
  }

  async loadMore() {
    if (this.isLoading || !this.nextUrl) return;

    this.isLoading = true;
    this.loading.style.display = 'block';

    try {
      const response = await fetch(this.nextUrl);
      const html = await response.text();

      // Parse the HTML response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get new products
      const newProducts = doc.querySelectorAll('#product-grid > li');

      if (newProducts.length > 0) {
        // Append new products to the grid
        newProducts.forEach((product) => {
          this.productGrid.appendChild(product.cloneNode(true));
        });

        // Update pagination info
        const newTrigger = doc.querySelector('.infinite-scroll-trigger');
        if (newTrigger && newTrigger.dataset.nextUrl) {
          this.nextUrl = newTrigger.dataset.nextUrl;
          this.currentPage = parseInt(newTrigger.dataset.currentPage);
          this.trigger.dataset.nextUrl = this.nextUrl;
          this.trigger.dataset.currentPage = this.currentPage;
        } else {
          // No more pages
          this.nextUrl = null;
          this.showEndMessage();
        }

        // Trigger custom event for other scripts (like lazy loading)
        document.dispatchEvent(
          new CustomEvent('infiniteScroll:loaded', {
            detail: { products: newProducts },
          })
        );
      } else {
        this.showEndMessage();
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      this.loading.innerHTML = '<p style="color: red;">Error loading products. Please refresh the page.</p>';
    } finally {
      this.isLoading = false;
      if (this.nextUrl) {
        this.loading.style.display = 'none';
      }
    }
  }

  showEndMessage() {
    this.loading.style.display = 'none';
    this.endMessage.style.display = 'block';
    this.observer.disconnect();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
} else {
  new InfiniteScroll();
}
